module.exports = "<th>Балкон</th>\n<td>\n  <div class=\"filter__button-group\">\n    <!-- Директива term не умеет работать с частями range -->\n    <div\n      class=\"s-button\"\n      ng-click=\"source.balconies.value.gte = (source.balconies.value.gte === 1) ? null : 1\"\n      ng-class=\"{'s-button_active': source.balconies.value.gte === 1}\"\n    >\n      <div class=\"s-button__text\">Есть балкон</div>\n    </div>\n\n    <term\n      source=\"source.loggia\"\n      behavior=\"checkbox\"\n      text=\"Есть лоджия\"/>\n  </div>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/balkon.html
// module id = 313
// module chunks = 0